// src/pages/Home/Components/FeaturedProducts.jsx
import { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ProductCard from '../../../components/ui/ProductCard';
import ErrorBoundary from '../../../components/ErrorBoundary';

const FeaturedProducts = () => {
  const { products, loading } = useSelector((state) => state.listProduct) || { products: [], loading: false };
  const [activeTab, setActiveTab] = useState('best');

  const availableProducts = useMemo(() => {
    if (!products || products.length === 0) return [];
    return products.filter((p) => p.countInStock > 0);
  }, [products]);

  const getSortedProducts = useMemo(() => {
    if (availableProducts.length === 0) return [];

    const sorted = [...availableProducts];

    if (activeTab === 'best') {
      return sorted.sort((a, b) => (b.rating || 0) - (a.rating || 0));
    } else if (activeTab === 'popular') {
      return sorted.sort((a, b) => (b.numReviews || 0) - (a.numReviews || 0));
    }

    return sorted;
  }, [availableProducts, activeTab]);

  if (loading) {
    return (
      <div className="max-w-[1280px] w-[95%] m-auto mt-10">
        <div className="h-[100px] rounded-2xl flex items-center justify-center" style={{ backgroundColor: '#9EAD8C' }}>
          <p className="text-white text-sm">در حال بارگذاری محصولات...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-[1280px] w-[95%] m-auto pt-10 pb-10">

      <div className="rounded-t-2xl py-4 px-4" style={{ backgroundColor: '#9EAD8C' }}>
        <h2 className="text-white text-sm md:text-base font-bold text-center mb-3">
          محصولات خلاقانه اریس گالری
        </h2>

        <div className="flex justify-center items-center text-xs sm:text-sm gap-6 overflow-x-auto px-2">
          <button
            onClick={() => setActiveTab('best')}
            className={`cursor-pointer whitespace-nowrap transition-all duration-200 pb-1 ${
              activeTab === 'best' ? 'text-black font-bold border-b-2' : 'text-white/60 hover:text-white/80'
            }`}
            style={{ borderColor: activeTab === 'best' ? '#000000' : 'transparent' }}
          >
            پرفروش‌ترین این ماه
          </button>

          <button
            onClick={() => setActiveTab('popular')}
            className={`cursor-pointer whitespace-nowrap transition-all duration-200 pb-1 ${
              activeTab === 'popular' ? 'text-black font-bold border-b-2' : 'text-white/60 hover:text-white/80'
            }`}
            style={{ borderColor: activeTab === 'popular' ? '#000000' : 'transparent' }}
          >
            محبوب‌ترین محصولات
          </button>
        </div>
      </div>

      <div className="-mt-5">
        <ErrorBoundary fallbackMessage="مشکلی در نمایش محصولات ویژه پیش آمد.">
          {getSortedProducts.length > 0 ? (
            <Swiper
              key={activeTab}
              dir="rtl"
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true, dynamicBullets: true }}
              className="w-full !pb-12"
              spaceBetween={16}
              slidesPerView={5}
              breakpoints={{
                0: { spaceBetween: 10, slidesPerView: 1.2 },
                380: { spaceBetween: 10, slidesPerView: 1.5 },
                480: { spaceBetween: 10, slidesPerView: 2 },
                640: { slidesPerView: 2.5 },
                768: { slidesPerView: 3.2 },
                1024: { slidesPerView: 4.2 },
                1280: { slidesPerView: 5 },
              }}
            >
              {getSortedProducts.map((product) => (
                <SwiperSlide key={product._id} className="!h-auto">
                  <div className="px-1 py-2">
                    <ProductCard {...product} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="text-center py-8 text-sm" style={{ color: '#79716B' }}>
              محصولی برای نمایش وجود ندارد.
            </div>
          )}
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default FeaturedProducts;